<template>
  <div>
    <div class="mb-5 text-center">
      <img src="../assets/logo.svg" width="200" alt="RouteLogic logo">
    </div>

    <div class="row">
      <div class="col-md-6 mx-auto">
        <div class="card">
          <div class="card-body">
            <div class="text-center">
              <img
                src="../assets/illustrations/undraw_empty_xct9.svg"
                width="150"
                alt="Illustratie"
                class="mb-3"
              >

              <h1 class="h5 mb-3">Pagina niet gevonden</h1>

              <p class="text-muted">De pagina die je probeert te bereiken bestaat niet.</p>

              <a href="https://www.routelogic.nl">
                <font-awesome-icon icon="arrow-left" class="mr-2" />Terug naar homepage
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'not-found',
};
</script>
